(() => {
  const roots = document.querySelectorAll('[data-zm-subscribe]');
  if (!roots.length) return;

  const formatMoney = (cents, currency) => {
    const value = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(value);
    } catch {
      return `${value.toFixed(2)} ${currency}`;
    }
  };

  const closeAll = () => {
    document.querySelectorAll('[data-zm-dd].is-open').forEach(dd => {
      dd.classList.remove('is-open');
      const btn = dd.querySelector('[data-zm-dd-btn]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  };

  document.addEventListener('click', (e) => {
    const dd = e.target.closest?.('[data-zm-dd]');
    if (!dd) closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  roots.forEach(root => {
    const plansEl = root.querySelector('[data-zm-selling-plans]');
    const tiles = Array.from(root.querySelectorAll('[data-zm-mode]'));
    const sellingPlanInput = root.querySelector('[data-zm-selling-plan]');
    const freqWrap = root.querySelector('[data-zm-frequency]');
    const select = root.querySelector('[data-zm-frequency-select]');
    const priceOneEl = root.querySelector('[data-zm-price-onetime]');
    const priceSubEl = root.querySelector('[data-zm-price-sub]');

    if (!plansEl || !tiles.length || !sellingPlanInput || !freqWrap || !select) return;

    const centsRaw = root.getAttribute('data-zm-price-cents');
    const baseCents = centsRaw ? parseInt(centsRaw, 10) : 0;

    const currency =
      root.getAttribute('data-zm-currency') ||
      document.documentElement.getAttribute('data-shopify-currency') ||
      window.Shopify?.currency?.active ||
      'SEK';

    if (priceOneEl) priceOneEl.textContent = formatMoney(baseCents, currency);

    const subCents = Math.max(0, Math.round(baseCents * 0.9));
    if (priceSubEl) priceSubEl.textContent = formatMoney(subCents, currency);

    const groups = JSON.parse(plansEl.textContent || '[]');
    const plans = [];

    for (const g of groups) {
      for (const p of (g.selling_plans || [])) {
        const label = p.options && p.options[0] ? p.options[0].value : 'Prenumeration';
        plans.push({ id: p.id, label });
      }
    }

    const numberFromLabel = (label) => {
      const m = String(label).match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 999;
    };

    plans.sort((a, b) => numberFromLabel(a.label) - numberFromLabel(b.label));

    select.innerHTML = plans.map(p => `<option value="${p.id}">${p.label}</option>`).join('');

    const dd = root.querySelector('[data-zm-dd]');
    const ddBtn = root.querySelector('[data-zm-dd-btn]');
    const ddText = root.querySelector('[data-zm-dd-text]');
    const ddMenu = root.querySelector('[data-zm-dd-menu]');

    const syncDd = () => {
      if (!dd || !ddText || !ddMenu) return;
      const selectedText = select.options[select.selectedIndex]?.textContent || '';
      ddText.textContent = selectedText;
      ddMenu.querySelectorAll('.zm-dd__opt').forEach(opt => {
        opt.classList.toggle('is-selected', opt.getAttribute('data-value') === select.value);
      });
    };

    if (dd && ddBtn && ddMenu && ddText) {
      ddMenu.innerHTML = plans.map(p => {
        return `<div class="zm-dd__opt" role="option" tabindex="0" data-value="${p.id}">
          <span>${p.label}</span>
          <span class="zm-dd__check" aria-hidden="true"></span>
        </div>`;
      }).join('');

      ddBtn.addEventListener('click', () => {
        const isOpen = dd.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          dd.classList.add('is-open');
          ddBtn.setAttribute('aria-expanded', 'true');
          ddMenu.focus();
        }
      });

      ddMenu.addEventListener('click', (e) => {
        const opt = e.target.closest('.zm-dd__opt');
        if (!opt) return;
        select.value = opt.getAttribute('data-value') || '';
        select.dispatchEvent(new Event('change', { bubbles: true }));
        syncDd();
        closeAll();
      });

      ddMenu.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const opt = e.target.closest('.zm-dd__opt');
        if (!opt) return;
        e.preventDefault();
        select.value = opt.getAttribute('data-value') || '';
        select.dispatchEvent(new Event('change', { bubbles: true }));
        syncDd();
        closeAll();
      });

      syncDd();
    }

    const setMode = (mode) => {
      tiles.forEach(t => t.classList.toggle('is-active', t.getAttribute('data-zm-mode') === mode));

      // ALWAYS toggle benefit panels
      const panels = Array.from(root.querySelectorAll('[data-zm-benefit-panel]'));
      panels.forEach(panel => {
        const match = panel.getAttribute('data-zm-benefit-panel') === mode;
        panel.classList.toggle('is-active', match);
        panel.setAttribute('aria-hidden', match ? 'false' : 'true');
      });

      if (mode === 'sub') {
        freqWrap.hidden = false;
        sellingPlanInput.value = select.value || '';
      } else {
        freqWrap.hidden = true;
        sellingPlanInput.value = '';
      }
    };

    tiles.forEach(t => t.addEventListener('click', () => setMode(t.getAttribute('data-zm-mode'))));

    select.addEventListener('change', () => {
      if (dd) syncDd();
      const active = tiles.find(t => t.classList.contains('is-active'));
      if (active && active.getAttribute('data-zm-mode') === 'sub') {
        sellingPlanInput.value = select.value || '';
      }
    });

    setMode('sub');
  });
})();
